import React, { useCallback, useState } from 'react';

import { Tab, Tabs } from '@material-ui/core';

import QuestionField from 'pages/Teachers/shared/TranscriptionsAndSolutionsMarkdownField';

import Button from 'components/Button';
import Dialog from 'components/Dialog';
import Typography from 'components/Typography';

import styles from './styles.module.scss';

const EditorDialog = ({
  open,
  onClose,
  answer,
  question,
  activeIndex,
  onConfirm,
  onCreate,
  inCreateMode = false
}) => {
  const [tabIndex, setTabIndex] = useState(0);
  const [curretAnswer, setCurretAnswer] = useState(answer);
  const [curretQuestion, setCurretQuestion] = useState(question);

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  const handleQuestionChange = useCallback((value) => {
    setCurretQuestion(value);
  }, []);

  const handleAnswerChange = useCallback((value) => {
    setCurretAnswer(value);
  }, []);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      classes={{ paper: styles.dialog }}
      maxWidth="lg"
      showClose={false}
    >
      <Button
        className={styles.completeButton}
        onClick={() => {
          if (activeIndex !== null && !inCreateMode) {
            onConfirm({
              transcription: curretQuestion,
              solution: curretAnswer
            });
          }
          if (inCreateMode) {
            onCreate({ transcription: curretQuestion, solution: curretAnswer });
          }
        }}
        disabled={
          (curretQuestion === '' || curretAnswer === '') && inCreateMode
        }
      >
        Confirm
      </Button>
      <Button className={styles.cancelButton} onClick={onClose}>
        Cancel
      </Button>
      <Typography variant="H-TEXT-2" className={styles.header}>
        Edit Content
      </Typography>
      <div className={styles.content}>
        <Tabs value={tabIndex} onChange={handleTabChange}>
          <Tab label="Question" />
          <Tab label="Answer" />
        </Tabs>

        <div className={styles.tabContent}>
          {tabIndex === 0 && (
            <QuestionField
              initalValue={curretQuestion}
              onChange={handleQuestionChange}
            />
          )}
          {tabIndex === 1 && (
            <QuestionField
              initalValue={curretAnswer}
              onChange={handleAnswerChange}
            />
          )}
        </div>
      </div>
    </Dialog>
  );
};

export default EditorDialog;
